export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS'
export const REMOVE_CREDIT_CARD = 'REMOVE_CREDIT_CARD'
export const INIT_PAYMENT = 'INIT_PAYMENT'
export const PSP_VERIFICATION_RESPONSE = 'PSP_VERIFICATION_RESPONSE'
export const SECURE3D_RESPONSE = 'SECURE3D_RESPONSE'
export const SECURE3D_CANCELLED = 'SECURE3D_CANCELLED'
export const SET_DEFAULT_CREDIT_CARD = 'SET_DEFAULT_CREDIT_CARD'
